// Hacky wraper for jquery slider pips.
import { clamp, quantize } from "apparatus/library/common";
import { focusMainApp, Keys } from "keyboard";
import * as React from "react";
import { Slider } from "./slider";
export class ComboSlider extends React.Component {
    constructor(props) {
        super(props);
        this.onSlideStart = () => {
            var _a;
            (_a = this.props.onStart) === null || _a === void 0 ? void 0 : _a.call(null);
        };
        // Called when slider changed by sliding
        this.onSlideChange = (value) => {
            this.setState({ inputText: this.inputText(value) });
            this.props.onChange(value);
        };
        // Called when slider changed by setting a value.
        this.onSlideEnd = (initialValue, value) => {
            this.setState({ value: value, inputText: this.inputText(value) });
            this.props.onEnd(initialValue, value);
        };
        this.state = { value: props.initialValue, inputText: this.inputText(props.initialValue) };
    }
    /** Calculates input value to show in the input field. */
    inputText(value) {
        if (this.props.unit === "%") {
            return Math.round(value * 100).toString();
        }
        return value.toString();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.initialValue != this.props.initialValue) {
            if (prevState.value != this.props.initialValue) {
                this.setState({
                    value: this.props.initialValue,
                    inputText: this.inputText(this.props.initialValue)
                });
            }
        }
    }
    /** Handle change when the input is typed into. */
    onInputChange(event) {
        let value = event.target.value;
        this.setState({ inputText: value });
    }
    /** Handle change when the input loses focus. */
    onInputBlur(event) {
        var _a;
        let value = event.target.value;
        let convertedValue = +value;
        if (isNaN(convertedValue)) {
            // Invalid value, reset back to original value and return.
            this.setState({ inputText: this.props.initialValue.toString() });
            return;
        }
        // Special handling based on unit.
        if (this.props.unit === "%") {
            convertedValue = convertedValue / 100;
        }
        // Clamp the value to range.
        convertedValue = clamp(convertedValue, this.props.min, this.props.max);
        // Round it to expected steps.
        convertedValue = quantize(convertedValue, this.props.min, (_a = this.props.step) !== null && _a !== void 0 ? _a : 1);
        // Invoke callback.
        this.props.onEnd(this.props.initialValue, convertedValue);
        // Set value for input.
        this.setState({ inputText: this.inputText(convertedValue) });
    }
    render() {
        const comboClass = this.props.unit ? "combo-3" : "combo-2";
        return React.createElement(React.Fragment, null,
            React.createElement(Slider, { key: "slider", initialValue: this.state.value, min: this.props.min, max: this.props.max, step: this.props.step, pipsStep: this.props.pipsStep, formatLabel: this.props.formatLabel, onChange: this.onSlideChange, onStart: this.onSlideStart, onEnd: this.onSlideEnd, extraClass: `combo ${comboClass}` }),
            React.createElement("input", { key: "input", className: "slider-input ui-input " + comboClass, value: this.state.inputText, onChange: e => this.onInputChange(e), onBlur: e => this.onInputBlur(e), onKeyDown: e => { if (e.keyCode == Keys.ENTER)
                    focusMainApp(); } }),
            this.props.unit ? React.createElement("span", { className: "slider-input-unit" }, this.props.unit) : undefined);
    }
}
